import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { useParams } from 'react-router-dom';

import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Checkin from './components/Checkin';
import Register from './components/Register';
import AutoMatch from './components/AutoMatch';
import PlayerManager from './components/PlayerManager';
import Monitor from "./components/Monitor";
import AdminMonitor from './components/AdminMonitor';
import PlayerHistory from './components/PlayerHistory';
import LineAuth from './components/LineAuth';
import RankTable from './components/RankTable';
import JoinCheckin from './components/JoinCheckin';
import QrCheckinLogin from './components/QrCheckinLogin';
import GroupMatchAdmin from './components/GroupMatchAdmin';
import SystemAdmin from './components/SystemAdmin';
import Reward from './components/Reward';
import AdminRewards from './components/AdminRewards';
import MatchPlanner from './components/MatchPlanner';
import MatchRequest from './components/MatchRequest';
/* ================= AUTO MATCH ================= */

function AutoMatchWrapper() {
  const { groupId } = useParams();
  return <AutoMatch groupId={Number(groupId)} />;
}

/* ================= PLAYER MANAGER ================= */

function PlayerManagerWrapper() {
  const { groupId } = useParams();
  return <PlayerManager groupId={Number(groupId)} />;
}

/* ================= APP ================= */

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/profile" element={<PlayerHistory profileMode />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/checkin" element={<Checkin />} />
        <Route path="/join/:groupId" element={<JoinCheckin />} />
        <Route path="/join/:groupId/login" element={<QrCheckinLogin />} />
        <Route path="/Register" element={<Register />} />
        <Route path="/monitor" element={<Monitor />} />
        <Route path="/monitor/:groupId" element={<Monitor />} />
        <Route path="/player-history/:groupId/:userId" element={<PlayerHistory />} />
        <Route path="/line-auth" element={<LineAuth />} />
        <Route path="/gameauto/:groupId" element={<AutoMatchWrapper />} />
        <Route path="/players/:groupId" element={<PlayerManagerWrapper />} />
        <Route path="/admin_monitor" element={<AdminMonitor />} />
<Route path="/admin_monitor/:groupId" element={<AdminMonitor />} />
        <Route path="/admin/group/:groupId/matches" element={<GroupMatchAdmin />} />
        <Route path="/admin/users" element={<SystemAdmin />} />
        <Route path="/rewards" element={<Reward />} />
        <Route path="/admin/rewards" element={<AdminRewards />} />
        <Route path="/match-planner/:groupId" element={<MatchPlanner />} />
        <Route path="/match-request" element={<MatchRequest />} />
<Route
  path="/rank"
  element={<RankTable />}
/>
      </Routes>
    </Router>
  );
}

export default App;
